import React, {FC, useState} from 'react'
import {Button, Select, Stack, TextArea, TextField} from '@mdsol/onex-design'
// @ts-ignore
import {DatePicker, TimePicker} from 'onex-latest'
import {useSelector} from 'react-redux'
import {useAppDispatch} from 'redux/config'
import {
  jobRequestAC,
  fetchStudies,
  loadData,
  fetchStudyEnvironments} from '../../../redux/jobRequests/jobRequests.duck'
import {
  select_jobRequestFormVM,
} from 'redux/jobRequests/selectors'
import {getSelectValue, getStudyEnvironmentSelectValue} from 'redux/jobRequests/helpers'
import './jobRequests.scss'
import {UrlSelection} from 'commonTypes'

const NewJobRequest: FC = () => {
  const dispatch = useAppDispatch()
  const {
    jobRequestCategory,
    dataLoadTopic,
    databaseId,
    databaseName,
    studyUuid,
    studyName,
    dateIsChosen,
    timeIsChosen,
    enableKafkaTopic,
    enableDataVerificationHashObject,
    enableStudy,
    isStudyRequired,
    enableChangesAfterDate,
    enableObjectId,
    enableStudyEnvironment,
    requiredObjectId,
    jobRequestCategorySelectorOptions,
    dataLoadTopicSelectorOptions,
    databaseSelectorValues,
    selectStudyOptions,
    dataVerificationHashObjectSelectorOptions,
    dataVerificationHashObject,
    requiredObjectIdText,
    jobRequestButtonDisabled,
    selectStudyEnvironmentsOptions,
    studyId,
    studyEnvironmentName,
    studyEnvironmentUuid,
    defaultMenuIsOpen,
  } = useSelector(select_jobRequestFormVM)

  const [allUrlsSelected, setAllUrlsSelected] = useState(false)
  const [specifyUrlsSelected, setSpecifyUrlsSelected] = useState(false)
  const [urlsSpecified, setUrlsSpecified] = useState(false)

  const handleSelectDataLoadCategory = option => {
    if (option) {
      dispatch(jobRequestAC.jobRequestCategoryApplied(option))
    } else {
      dispatch(jobRequestAC.jobRequestCategoryReset())
      dispatch(jobRequestAC.studyReset())
      dispatch(jobRequestAC.studyEnvironmentReset())
    }
    dispatch(jobRequestAC.databaseReset())
    dispatch(jobRequestAC.dataLoadTopicReset())
  }

  const handleSelectDataLoadTopic = option => {
    if (option) {
      dispatch(jobRequestAC.dataLoadTopicApplied(option))
    } else {
      dispatch(jobRequestAC.dataLoadTopicReset())
    }
  }

  const handleSelectDatabase = option => {
    if(option) {
      const {label, subLabel} = option
      if (label === 'All') {
        setAllUrlsSelected(true)
        setSpecifyUrlsSelected(false)
        dispatch(jobRequestAC.databaseApplied(label, subLabel, UrlSelection.ALL))
        dispatch(jobRequestAC.studyReset())
      } else if (label === 'Specify Urls') {
        setSpecifyUrlsSelected(true)
        setAllUrlsSelected(false)
        dispatch(jobRequestAC.databaseApplied(label, subLabel, UrlSelection.MULTIPLE))
        dispatch(jobRequestAC.studyReset())
      } else {
        setAllUrlsSelected(false)
        setSpecifyUrlsSelected(false)
        dispatch(jobRequestAC.databaseApplied(label, subLabel, UrlSelection.ONE))
        dispatch(fetchStudies())
      }
    } else {
      dispatch(jobRequestAC.databaseApplied('', '', UrlSelection.EMPTY))
      dispatch(jobRequestAC.studyReset())
    }
  }

  const handleSelectDataVerificationHashObject = option => {
    if (option) {
      dispatch(jobRequestAC.dataVerificationHashObjectApplied(option))
    } else {
      dispatch(jobRequestAC.dataVerificationHashObjectReset())
    }
  }

  const handleSelectStudy = option => {
    if (option) {
      const studyName = option.label
      const studyUuid = option.subLabel
      dispatch(jobRequestAC.studyApplied(studyName, studyUuid))
      if (enableStudyEnvironment) {
        dispatch(fetchStudyEnvironments())
      }
    } else {
      dispatch(jobRequestAC.studyApplied('', ''))
    }
  }

  const handleSelectStudyEnvironment = option => {
    if (option) {
      const studyId = option.value
      const studyEnvironmentName = option.label
      const studyEnvironmentUuid = option.subLabel
      dispatch(jobRequestAC.studyEnvironmentApplied(studyId, studyEnvironmentName, studyEnvironmentUuid))
    } else {
      dispatch(jobRequestAC.studyEnvironmentApplied(0, '', ''))
    }
  }

  const handleSelectDate = (date) => {
    if (date.value) {
      dispatch(jobRequestAC.changesAfterDateApplied(date.value.toISOString()))
    } else {
      dispatch(jobRequestAC.changesAfterTimeReset())
      dispatch(jobRequestAC.changesAfterDateReset())
    }
  }

  const handleTimePick = (time) => {
    if (time.value) {
      const now = new Date(time.value)
      const utc = new Date(now.getTime() - now.getTimezoneOffset() * 60000)
      dispatch(jobRequestAC.changesAfterTimeApplied(utc.toISOString()))
    } else {
      dispatch(jobRequestAC.changesAfterTimeReset())
    }
  }

  const handleObjectIdAdd = (text) => {
    dispatch(jobRequestAC.objectIdApplied(text))
  }

  const handleSpecifyUrlsAdd = (text) => {
    setUrlsSpecified(text.length > 0)
    dispatch(jobRequestAC.specifyUrlsApplied(text))
  }

  const handleLoadData = () => {
    dispatch(loadData())
  }

  return (
    <div id='new-job-create-request-form' role='data-load-request-form'>
      <Stack className='permanent-dropdowns' key='permanent-ddls'>
        <Select
          data-role='category-selector'
          key='job-request-category-selector'
          className='permanent-ddl'
          dataTestId='select-job-request-category'
          filterBy={['label']}
          options={jobRequestCategorySelectorOptions}
          value={jobRequestCategory}
          onSelect={handleSelectDataLoadCategory}
          label='Job Request Category'
          labelFieldId='Job Request Category Label Id'
          size='sm'
          defaultMenuIsOpen={defaultMenuIsOpen}
          required
        />
        {enableKafkaTopic &&
          <Select
            data-role='topic-selector'
            key='kafka-topic-selector'
            className='dynamic-ddl'
            dataTestId='select-kafka-topic'
            filterBy={['label']}
            options={dataLoadTopicSelectorOptions}
            value={dataLoadTopic}
            onSelect={handleSelectDataLoadTopic}
            label='Data Load Topic'
            labelFieldId='Data Load Topic Label Id'
            size='sm'
            defaultMenuIsOpen={defaultMenuIsOpen}
            isClearable
            required
          />
        }
        <Select
          key='database-selector'
          className='dynamic-ddl'
          dataTestId='select-database'
          filterBy={['label', 'subLabel']}
          options={databaseSelectorValues}
          value={getSelectValue(databaseId, databaseName)}
          onSelect={handleSelectDatabase}
          label='Url'
          labelFieldId='Database Label Id'
          informativeText='Select Rave Url'
          menuPosition='fixed'
          size='sm'
          defaultMenuIsOpen={defaultMenuIsOpen}
          required
        />
        {specifyUrlsSelected &&
          <div className='custom-url-textarea'>
            <TextArea
              className='custom-textarea'
              dataTestId='specify-urls-id'
              id='custom-textarea-specify-urls-id'
              label='Specify Urls'
              size='sm'
              rows={10}
              informativeText='Enter Urls separated by comma, new line or space in the format: abc.mdsol.com'
              placeholder='Enter Urls separated by comma, new line or space in the format: abc.mdsol.com'
              onChange={handleSpecifyUrlsAdd}
            />
          </div>
        }
        {enableDataVerificationHashObject &&
          <Select
            data-role='data-verification-hash-object-selector'
            key='data-verification-hash-object-selector'
            className='dynamic-ddl'
            dataTestId='select-data-verification-hash-object'
            filterBy={['label']}
            options={dataVerificationHashObjectSelectorOptions}
            value={dataVerificationHashObject}
            onSelect={handleSelectDataVerificationHashObject}
            label='Object Name'
            labelFieldId='Data Verification Hash Object Label Id'
            size='sm'
            defaultMenuIsOpen={defaultMenuIsOpen}
            isClearable
            required
          />
        }
        {enableStudy && !allUrlsSelected && !specifyUrlsSelected &&
          <Select
            key='study-uuid-selector'
            className='dynamic-ddl'
            dataTestId='select-study'
            filterBy={['label', 'subLabel']}
            options={selectStudyOptions}
            value={getSelectValue(studyUuid, studyName)}
            onSelect={handleSelectStudy}
            label='Study UUID'
            labelFieldId='Study UUID Label Id'
            informativeText={isStudyRequired ? 'Select Study' : 'optional'} 
            size='sm'
            defaultMenuIsOpen={defaultMenuIsOpen}
            required={isStudyRequired}
          />
        }
        {enableChangesAfterDate && !allUrlsSelected && !specifyUrlsSelected &&
          <div className='date-time-input'>
            <DatePicker
              calendarClassName='calendar-custom'
              className='custom-date-picker'
              dataTestId='date-picker-test-id'
              id='test-date-picker-id'
              label='Changes after UTC Date:'
              informativeText='Enter UTC date'
              isClearable
              maxDate={new Date()}
              minDate={new Date('2000-01-01T00:00:00.000Z')}
              onChange={handleSelectDate}
              placeholder='MM/DD/YY'
              size='sm'
              showTimeSelect={true}
              autoFocus={defaultMenuIsOpen}
            />
            <TimePicker
              className='custom-time-picker'
              dataTestId='time-picker-test-id'
              id='test-time-picker-id'
              label='UTC Time:'
              name='custom-time-picker-name'
              onChange={handleTimePick}
              placeholder='HH/MM'
              size='sm'
              disabled={!dateIsChosen}
              informativeText='Enter UTC time'
              autoFocus={defaultMenuIsOpen}
              isClearable
              value={timeIsChosen}
            />
          </div>
        }
        {enableObjectId && !allUrlsSelected && !specifyUrlsSelected &&

          <TextField
            className='custom-textfield'
            dataTestId='objectid-test-id'
            id='text-textfield-custom-id'
            label='Object Id'
            informativeText={requiredObjectId ? requiredObjectIdText : 'optional'}
            onChange={handleObjectIdAdd}
            showClearBtn
            size='sm'
            required={requiredObjectId}
          />

        }
        {enableStudyEnvironment && !allUrlsSelected && !specifyUrlsSelected &&
          <Select
            key='study-environment-selector'
            className='dynamic-ddl'
            dataTestId='select-study-environment'
            filterBy={['label', 'subLabel']}
            options={selectStudyEnvironmentsOptions}
            value={getStudyEnvironmentSelectValue(studyId, studyEnvironmentName, studyEnvironmentUuid)}
            onSelect={handleSelectStudyEnvironment}
            label='Study Environment UUID'
            labelFieldId='Study Environment Label Id'
            informativeText='Select Study Environment'
            size='sm'
            defaultMenuIsOpen={defaultMenuIsOpen}
            required
          />
        }
        <div className='button-container'>
          <Button
            key='load-data-button'
            dataTestId='load-data-button'
            onClick={handleLoadData}
            size='sm'
            disabled={specifyUrlsSelected ? (jobRequestButtonDisabled || !urlsSpecified) : jobRequestButtonDisabled}
          >
            Load Data
          </Button>
        </div>
      </Stack>
    </div>
  )
}

export default NewJobRequest
